export const setFlag = (key, value) => ({
  type: 'SET_FLAG',
  data: { key, value },
})
